import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpEventType, HttpRequest} from '@angular/common/http';
import {last, map, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UploadUtilService {

  constructor(private http: HttpClient) { }

  uploadFile(url: string, data: {File, [key: string]: any}, updateFunction: ((percentageDone: number) => any) = null) {
    const formData = new FormData();
    formData.append('File', data.File, data.File.name);
    Object.keys(data).forEach(key => {
      if (key != 'File') {
        formData.append(key, data[key]);
      }
    })
    const req = new HttpRequest('POST', url, formData, {
      reportProgress: true,
    });
    let percentDone = 0;
    return this.http.request(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event.type == HttpEventType.UploadProgress) {
          percentDone = Math.round((100 * event.loaded) / event.total);
          if (updateFunction) {
            updateFunction(percentDone);
          }
        } else if (event.type === HttpEventType.Response) {
          return event.body;
        }
      }),
      last()
    );
  }
}
